<script lang="ts">
    
    import type { Cell } from "../../Model/Cell";

    export let cell: Cell;

</script>

<div class="number">{cell.number}</div>

<style lang="scss">

    .number {
        opacity: 0.25;
    }

</style>
